exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dashboard-container {\n  background-color: white;\n  border-radius: 5px;\n  padding: 25px;\n  border: 1px solid #eee; }\n", ""]);

// exports
